<template>
  <div class="classdetail" v-title :data-title="title">
    <div class="video">
      <van-sticky>
        <div class="prism-player" id="prismPlayer" v-if="detail.type != 'txt'">
          <img
            :src="courseData.appImageUrl"
            style="width: 100%; height: 100%"
            v-if="detail.type == 'audio'"
            alt=""
          />
        </div>
        <div class="block" v-if="detail.type != 'txt'">
          <div class="video_title">{{ detail.name }}</div>
          <div class="video_desc">{{ detail.title }}</div>
          <div class="video_num">
            <div class="">
              <span class="mr20">{{ detail.createDate }}</span>
              <span>{{ detail.duration | getTime }}</span>
            </div>
            <div>
              <span style="color: #ff960b">{{ learnedCount }}</span
              >人已学过
            </div>
          </div>
        </div>
      </van-sticky>

      <div class="ql-snow">
        <div
          class="block mt11 ftext ql-editor"
          v-html="detail.synopsis"
          @click="imageEnlargement"
          v-if="detail.type != 'txt'"
        ></div>
        <div
          class="block ftext ql-editor"
          v-if="detail.type == 'txt'"
          @click="imageEnlargement"
          v-html="detail.content"
        ></div>
      </div>
    </div>
    <div class="bottom_bar">
      <div class="back" @click="toback">返回课程</div>
    </div>
  </div>
</template>
<script>
import {
  addlearnedRecord,
  getVideoPlayAuth,
  userSubscribe,
  getCourseDetail,
} from "@/api/apis";
import { getJsApiTicket } from "@/api/users";
import { ImagePreview } from "vant";
import { getImgSrc } from "../../utils/index";
import { loading } from "../../utils/index";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import { isAndroid } from "../../utils/index";
export default {
  data() {
    return {
      title: "",
      detail: "",
      learnedCount: 0,
      url: "",
      enterTime: "",
      location: 0,
      is_over: false,
      imglist: [],
      index: 0,
      id: "",
      player:''
      // 视频播放
    };
  },
  methods: {
    toback() {
      if (sessionStorage.getItem("is_share") == 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/courseDetail",
          query: { courseId: this.courseId },
        });
      }
    },
    learnedRecord(key) {
      let _this = this;
      let leaveTime = new Date() * 1;
      let duration = (leaveTime - this.enterTime) / 1000;
      duration = duration.toFixed(0);

      let data = {
        chapterId: this.detail.id,
        courseId: this.courseId,
        duration: duration,
        enterTime: this.enterTime,
        leaveTime,
        location: this.location,
        userId: this.$store.state.user.user.user.id,
      };
      // this.player.off("timeupdate", this.addlisten);
      addlearnedRecord(data).then((res) => {
        if (key == 1) {
          console.log(23231);
          this.is_over = true;
          this.player.off("ended", this.ended);
        }
      });
    },
    // 监听事件
    addlisten() {
      this.location = this.player.getCurrentTime();
    },
    imageEnlargement(e) {
      let a = this.imglist.findIndex(
        (item) => item.split("//")[1] == e.target.currentSrc.split("//")[1]
      );
      let startPosition = a != -1 ? a : 0;
      console.log(startPosition, a);
      if (e.target.nodeName == "IMG") {
        //判断点击富文本内容为img图片
        ImagePreview({
          images: this.imglist, //获取当前图片src
          showIndex: false,
          loop: true,
          startPosition,
        });
      }
    },
    // 播放器初始化
    init() {
      let Aliplayer = window.Aliplayer;
      let that = this;
      let AliPlayerComponent = window.AliPlayerComponent;
      console.log(AliPlayerComponent);
      loading(true);
      getVideoPlayAuth(this.detail.content)
        .then((res) => {
          that.player = new Aliplayer(
            {
              id: "prismPlayer",
              width: "100%",
              autoplay: true,
              rePlay: true,
              //支持播放地址播放,此播放优先级最高
              //播放方式二：点播用户推荐
              vid: this.detail.content,
              skinLayout: [
                { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
                {
                  name: "H5Loading",
                  align: "cc",
                },
                { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
                { name: "infoDisplay" },
                { name: "tooltip", align: "blabs", x: 0, y: 56 },
                { name: "thumbnail" },
                {
                  name: "controlBar",
                  align: "blabs",
                  x: 0,
                  y: 0,
                  children: [
                    { name: "progress", align: "blabs", x: 0, y: 44 },
                    { name: "playButton", align: "tl", x: 15, y: 12 },
                    // { name: "timeDisplay", align: "tl", x: 10, y: 7 },
                    { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
                    { name: "subtitle", align: "tr", x: 15, y: 12 },
                    { name: "setting", align: "tr", x: 15, y: 12 },
                    { name: "volume", align: "tr", x: 5, y: 10 },
                  ],
                },
              ],
              playauth: res.PlayAuth,
              controlBarVisibility: "click",
              showBarTime: 5000,
              useH5Prism: true,
              playsinline: isAndroid() ? false : true,
              preload: true,
              qualitySort: "asc",
              x5_type: "h5",
              cover:
                this.detail.type == "audio"
                  ? this.courseData.appImageUrl
                  : res.CoverUrl,
              region: "cn-shanghai", //eu-central-1,ap-southeast-1
            },
            function (player) {
              loading(false);
              player.seek(that.detail.location);
              player.play();
              player.on("timeupdate", that.addlisten);
              player.on("ended", that.ended);
              player.on("resicancelFullScreenze", () => {
                player.cancelFullScreen("100%", "246px");
                console.log(443222);
              });
            }
          );
        })
        .catch(() => loading(false));
    },
    ended() {
      this.learnedRecord(1);
    },
    getCourseData(index) {
      getCourseDetail(this.courseId)
        .then((res) => {
          this.courseData = res;
          this.learnedCount = res.learnedCount;
          this.detail = this.getid(res.chapters);

          if (!this.detail) {
            this.Toast("该章节内容已发生改动，请返回课程详情页面刷新后再选择");
            return;
          }
          if (res.isSubscribe) {
            this.getwx();
            this.imglist = getImgSrc(this.detail.synopsis);
            this.title = this.detail.name;

            if (this.detail.type == "txt") {
              this.learnedRecord();
            } else {
              this.init();
            }
          } else {
            setTimeout(() => {
              Dialog.confirm({
                title: "提示",
                message:
                  "您还没有订阅该课程,请点击确认按钮订阅,否则无法正常观看该课程",
                beforeClose: this.beforeClose,
              });
            }, 300);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        userSubscribe({
          courseId: this.courseId,
          courseName: this.courseData.name,
        }).then((res) => {
          this.Toast("订阅成功");
          setTimeout(() => {
            this.getCourseData();
          }, 1000);

          done();
        });
      } else {
        done();
      }
    },
    // 微信分享
    getwx() {
      let that = this;
      const link = window.location.href.split("?")[0];
      // if (link !== window.location.href) {
      // 	window.location.href = link;
      // } //为了兼容iOS系统，否则有可能地址取值出现错误
      const url = window.location.href.split("#")[0];

      getJsApiTicket({
        link: url,
      }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式
          appId: res.body.appid, // 必填，公众号的唯一标识
          timestamp: res.body.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
          signature: res.body.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            "updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          ], // 必填，需要使用的JS接口列表
        });
      });
      wx.ready(function () {
        that.wxShareTimeline();
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
      wx.error((res) => {
        console.warn("微信注册", res);
      });
    },
    wxShareTimeline() {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      let { appImageUrl } = this.courseData;
      let { name, type } = this.detail;
      // let categoryName=chapters.map(res=>res.name).join(' 、')
      wx.updateAppMessageShareData({
        title: name, // 分享标题
        desc: type, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: appImageUrl, // 分享图标
        success: () => {
          console.log("设置成功1");
        },
      });
      wx.updateTimelineShareData({
        title: name, // 分享标题
        desc: type, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: appImageUrl, // 分享图标
        success: () => {
          console.log("设置成功2");
        },
      });
    },
    // 对比章节id
    getid(arr) {
      for (let a of arr) {
        if (a.id == this.id) {
          return a;
        }
      }
      return false;
    },
  },
  mounted() {
    let { courseId, id } = this.$route.query;
    this.enterTime = new Date() * 1;
    this.id = id;
    this.courseId = courseId;
    this.getCourseData();
  },
  filters: {
    getTime(val) {
      let min = val / 60;
      let second = val % 60;
      let time = "";
      if (Math.floor(min) > 0 && second > 0)
        time = Math.floor(min) + "分钟" + second + "秒";
      else if (Math.floor(min) > 0 && second == 0)
        time = Math.floor(min) + "分钟";
      else time = second + "秒";
      return time;
    },
  },
  beforeDestroy() {
    if (!this.is_over) {
      this.learnedRecord();
    }
  },
};
</script>
<style lang="less" >
.classdetail {
  width: 100%;
  padding-bottom: 94px;
  .prism-controlbar {
    .prism-cc-btn {
      display: none;
    }
  }
  .prism-setting-list {
    .prism-setting-cc {
      display: none !important;
    }
    .prism-setting-audio {
      display: none !important;
    }
  }
  .prism-player {
    height: 246px !important;
    // overflow: hidden;
    .prism-big-play-btn {
      left: 50% !important;
      bottom: 50% !important;
      width: 45px;
      height: 45px;
      // background-size: 128px 256px;
      transform: translate(-23px, 23px);
      .outter {
        width: 45px;
        height: 45px;
      }
    }
    //  video {
    // object-fit: contain !important;
    // }
  }

  .video {
    width: 100%;
    // height: 246px;
    video {
      height: 246px !important;
    }
  }
  .video_title {
    width: 339px;
    margin: 15px auto 0;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    text-align: left;
    font-family: PingFangSC-bold;
  }
  .video_desc {
    width: 339px;
    color: rgba(151, 144, 144, 100);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-regular;
    margin: 9px auto 0;
  }
  .video_num {
    display: flex;
    width: 339px;
    justify-content: space-between;
    align-items: center;
    color: #adadad;
    margin: 18px auto 0;
    font-size: 12px;
    .video_logo {
      width: 51px;
      height: 17px;
      line-height: 20px;
      border-radius: 2px;
      background-color: rgba(255, 150, 11, 100);
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 100);
      font-size: 10px;
      font-family: PingFangSC-bold;
      line-height: 17px;
      color: #fff !important;
    }
  }
  .block {
    padding: 1px 0 21px;
    background: #fff;
  }
  .mt11 {
    margin-top: 11px;
  }
  .back {
    width: 352px;
    height: 40px;
    border-radius: 20px;
    background-color: rgba(255, 150, 11, 100);
    color: rgba(255, 255, 255, 100);
    font-size: 16px;
    text-align: center;
    font-family: PingFang SC;
    border: 1px solid rgba(255, 255, 255, 100);
    line-height: 40px;
    text-align: center;
    position: fixed;
    bottom: 20px;
    left: 15px;
  }
  .ftext {
    padding: 27px 18px;
    box-sizing: border-box;
    // /deep/img {
    //   max-width: 100%;
    // }
  }
  .mr20 {
    margin-right: 16px;
  }
  .bottom_bar {
    width: 100%;
    height: 74px;
    position: fixed;
    bottom: 0;
    background: #f8f8f8 100%;
  }
}
</style>